import { Container } from '@bit/ui-common.ui-components/ss-components';
import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { commonData, captcha, help } from '@bit/ui-common.ui-components/ss-common-data';
import * as AppServices from 'services/appService';
import * as SessionService from 'services/sessionService';
import * as RegistrationCheckService from 'services/registrationCheckService';
import * as passwordUpdate from 'services/updatePasswordService'
import * as ProviderService from 'services/provider/providerService';
import * as CandidateServices from '../redux/services/candidateRegistrationServices';
import * as passwordResetServices from 'services/passwordResetServices';
import * as StatusService from 'services/statusService';
import Provider from 'components/registration/Provider';
import { ssFormServices, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import LoginDisabled from './LoginDisabled';
const
{ setEnvPrefix } = ssCommonUtils,
imagesPath = '/home/images',
layout = {
    bgc: '#e6e6e6',
    controlType: 'home',
    size: { header: 'xs', footer: 'xs' },
    images: {
        usePathname: false,
        logo: setEnvPrefix(`${imagesPath}/dhs-logo-01.png`),
        user: setEnvPrefix(`${imagesPath}/user-icon-01.png`),
    }
};

export default Container({
    services: [
        AppServices,
        SessionService,
        CandidateServices,
        passwordResetServices,
        RegistrationCheckService,
        passwordUpdate,
        ProviderService,
        ssFormServices,
        commonData.commonDataServices,
        captcha.captchaServices,
        help.helpServices,
        StatusService

    ]
},
class ProviderRegistration extends React.Component {
    constructor(props) { 
        super(props); 
        const { services } = this.props;
        services.fetchLoginStatus();

    }
    render() {
        const {state} = this.props;
        const {status} = state;
        if (status.nonPivLogin != 'N') {
            return (
                <div>
                    <AfspLayout {...layout}>{
                        <Provider {...this.props} />
                    }</AfspLayout>
                </div>
            );
        }else {
            return (
                <LoginDisabled  />
            )
        }
    }
});
